/* slider-bracelet-builder v3 - decorative only */
(function () {
  'use strict';

  var config = window.__sliderBracelet;
  if (!config) return;

  var MAX_SLOTS = config.maxSlots || 10;
  var basePrice = config.basePrice; // in cents
  var selectedVariantId = config.selectedVariantId;

  // State
  var slots = []; // Array of { slotIndex, charm } where charm = { id, variantId, title, handle, price, image, type }
  var activeSlotIndex = null;
  var allCharms = [].concat(config.charms.letters, config.charms.numbers, config.charms.decorative);
  var activeTab = 'all';
  var pendingPhotoCharm = null;
  var pendingPhotoSlotIndex = null;

  // ── Drag & Reorder State ──
  var dragJustCompleted = false;
  var drag = {
    active: false,
    sourceIndex: null,
    zone: null,
    ghost: null,
    sourceEl: null,
    startX: 0,
    startY: 0,
    thresholdMet: false,
    holdTimer: null,
    lastOverIndex: null,
    lastOverEl: null
  };

  function onDragPointerDown(e, slotIndex, zone, el) {
    if (e.button && e.button !== 0) return;
    e.preventDefault();
    drag.startX = e.clientX;
    drag.startY = e.clientY;
    drag.sourceIndex = slotIndex;
    drag.zone = zone;
    drag.sourceEl = el;
    drag.thresholdMet = false;
    drag.active = true;

    // Long-press to initiate drag (200ms)
    drag.holdTimer = setTimeout(function () {
      drag.holdTimer = null;
      enterDragMode(e);
    }, 200);

    el.setPointerCapture(e.pointerId);
    el.addEventListener('pointermove', onDragPointerMove);
    el.addEventListener('pointerup', onDragPointerUp);
    el.addEventListener('pointercancel', onDragPointerUp);
  }

  function enterDragMode(e) {
    if (drag.thresholdMet) return;
    drag.thresholdMet = true;

    // Create ghost
    var ghost = drag.sourceEl.cloneNode(true);
    ghost.style.position = 'fixed';
    ghost.style.pointerEvents = 'none';
    ghost.style.zIndex = '10000';
    ghost.style.opacity = '0.85';
    ghost.style.transform = 'scale(1.1)';
    ghost.style.margin = '0';
    ghost.style.width = drag.sourceEl.offsetWidth + 'px';
    ghost.style.height = drag.sourceEl.offsetHeight + 'px';
    ghost.style.left = (e.clientX - drag.sourceEl.offsetWidth / 2) + 'px';
    ghost.style.top = (e.clientY - drag.sourceEl.offsetHeight / 2) + 'px';
    ghost.classList.remove('is-drag-over');
    document.body.appendChild(ghost);
    drag.ghost = ghost;

    drag.sourceEl.classList.add('is-dragging');
    document.querySelector('.slider-builder').classList.add('is-dragging-active');

    // Suppress scroll on slots container during drag
    slotsContainer.style.overflowX = 'hidden';
    slotsContainer.style.touchAction = 'none';
  }

  function onDragPointerMove(e) {
    if (!drag.active) return;

    var dx = e.clientX - drag.startX;
    var dy = e.clientY - drag.startY;
    var dist = Math.sqrt(dx * dx + dy * dy);

    // Cancel hold timer if moved too far before hold completes
    if (!drag.thresholdMet && dist > 10 && drag.holdTimer) {
      clearTimeout(drag.holdTimer);
      drag.holdTimer = null;
      cleanupDrag();
      return;
    }

    if (!drag.thresholdMet) return;

    e.preventDefault();

    // Move ghost
    if (drag.ghost) {
      drag.ghost.style.left = (e.clientX - drag.sourceEl.offsetWidth / 2) + 'px';
      drag.ghost.style.top = (e.clientY - drag.sourceEl.offsetHeight / 2) + 'px';
    }

    // Hit test
    drag.ghost.style.display = 'none';
    var target = document.elementFromPoint(e.clientX, e.clientY);
    drag.ghost.style.display = '';

    var targetEl = null;
    var targetIndex = null;

    if (drag.zone === 'slots') {
      targetEl = target ? target.closest('.slider-builder__slot') : null;
      if (targetEl) {
        targetIndex = parseInt(targetEl.getAttribute('data-slot-index'), 10) - 1;
      }
    } else {
      targetEl = target ? target.closest('.slider-builder__preview-charm') : null;
      if (targetEl) {
        targetIndex = parseInt(targetEl.getAttribute('data-slot-index'), 10);
      }
    }

    // Update hover highlight
    if (drag.lastOverEl && drag.lastOverEl !== targetEl) {
      drag.lastOverEl.classList.remove('is-drag-over');
    }
    if (targetEl && targetIndex !== drag.sourceIndex) {
      targetEl.classList.add('is-drag-over');
      drag.lastOverEl = targetEl;
      drag.lastOverIndex = targetIndex;
    } else {
      drag.lastOverIndex = null;
      drag.lastOverEl = null;
    }
  }

  function onDragPointerUp(e) {
    if (!drag.active) return;

    var wasHolding = drag.holdTimer !== null;

    if (drag.holdTimer) {
      clearTimeout(drag.holdTimer);
      drag.holdTimer = null;
    }

    var didSwap = false;

    if (drag.thresholdMet && drag.lastOverIndex !== null && drag.lastOverIndex !== drag.sourceIndex) {
      swapSlots(drag.sourceIndex, drag.lastOverIndex);
      didSwap = true;
    }

    var sourceEl = drag.sourceEl;
    var wasDrag = drag.thresholdMet;
    cleanupDrag();

    if (didSwap) {
      dragJustCompleted = true;
      setTimeout(function () { dragJustCompleted = false; }, 50);
      refreshAll();
    } else if (!wasDrag && sourceEl) {
      // Was a tap, not a drag — simulate the click since we prevented default
      sourceEl.click();
    }
  }

  function swapSlots(fromIndex, toIndex) {
    var temp = slots[fromIndex];
    slots[fromIndex] = slots[toIndex];
    slots[toIndex] = temp;
  }

  function cleanupDrag() {
    if (drag.ghost) {
      drag.ghost.parentNode.removeChild(drag.ghost);
      drag.ghost = null;
    }
    if (drag.sourceEl) {
      drag.sourceEl.classList.remove('is-dragging');
      drag.sourceEl.removeEventListener('pointermove', onDragPointerMove);
      drag.sourceEl.removeEventListener('pointerup', onDragPointerUp);
      drag.sourceEl.removeEventListener('pointercancel', onDragPointerUp);
    }
    if (drag.lastOverEl) {
      drag.lastOverEl.classList.remove('is-drag-over');
    }
    var builder = document.querySelector('.slider-builder');
    if (builder) builder.classList.remove('is-dragging-active');
    slotsContainer.style.overflowX = '';
    slotsContainer.style.touchAction = '';
    drag.active = false;
    drag.thresholdMet = false;
    drag.sourceIndex = null;
    drag.zone = null;
    drag.sourceEl = null;
    drag.lastOverIndex = null;
    drag.lastOverEl = null;
  }

  // DOM references
  var slotsContainer = document.getElementById('sliderSlots');
  var previewCharms = document.getElementById('sliderPreviewCharms');
  var addonRow = document.getElementById('sliderAddonRow');
  var addonPrice = document.getElementById('sliderAddonPrice');
  var totalPrice = document.getElementById('sliderTotalPrice');
  var baseDisplay = document.getElementById('sliderBasePrice');
  var addToCartBtn = document.getElementById('sliderAddToCart');
  var addToCartText = document.getElementById('sliderAddToCartText');
  var picker = document.getElementById('sliderPicker');
  var pickerGrid = document.getElementById('sliderPickerGrid');
  var pickerClose = document.getElementById('sliderPickerClose');
  var pickerTabs = document.getElementById('sliderPickerTabs');
  var pickerOverlay = picker.querySelector('.slider-builder__picker-overlay');

  // ── Utility ──

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function generateBundleId() {
    return 'slider_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
  }

  // ── Slot Management ──

  function getFilledSlots() {
    return slots.filter(function (s) { return s !== null; });
  }

  function getDecorativeTotal() {
    var total = 0;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i] && slots[i].charm.type === 'decorative') {
        total += slots[i].charm.price;
      }
    }
    return total;
  }

  function updatePricing() {
    var addonTotal = getDecorativeTotal();
    var total = basePrice + addonTotal;

    baseDisplay.textContent = formatMoney(basePrice);

    if (addonTotal > 0) {
      addonRow.style.display = '';
      addonPrice.textContent = formatMoney(addonTotal);
    } else {
      addonRow.style.display = 'none';
    }

    totalPrice.textContent = formatMoney(total);
  }

  function updateAddToCartState() {
    var filled = getFilledSlots();
    if (filled.length >= 1) {
      addToCartBtn.disabled = false;
      addToCartText.textContent = 'Add to Cart — ' + formatMoney(basePrice + getDecorativeTotal());
    } else {
      addToCartBtn.disabled = true;
      addToCartText.textContent = 'Select at least 1 charm';
    }
  }

  function updateSlotUI() {
    var slotBtns = slotsContainer.querySelectorAll('.slider-builder__slot');
    for (var i = 0; i < slotBtns.length; i++) {
      var btn = slotBtns[i];
      var slotData = slots[i] || null;
      var plus = btn.querySelector('.slider-builder__slot-plus');
      var img = btn.querySelector('.slider-builder__slot-img');
      var remove = btn.querySelector('.slider-builder__slot-remove');

      if (slotData) {
        plus.style.display = 'none';
        img.src = slotData.charm.image;
        img.alt = slotData.charm.title;
        img.style.display = '';
        remove.style.display = '';
        btn.classList.add('is-filled');
        btn.setAttribute('aria-label', 'Slot ' + (i + 1) + ' - ' + slotData.charm.title);
      } else {
        plus.style.display = '';
        img.style.display = 'none';
        img.src = '';
        img.alt = '';
        remove.style.display = 'none';
        btn.classList.remove('is-filled');
        btn.setAttribute('aria-label', 'Slot ' + (i + 1) + ' - empty');
      }
    }
  }

  function updatePreview() {
    var filled = getFilledSlots();
    var emptyMsg = document.getElementById('sliderPreviewEmpty');
    var cord = document.getElementById('sliderPreviewCord');

    if (filled.length === 0) {
      if (emptyMsg) emptyMsg.style.display = '';
      if (cord) cord.style.display = 'none';
      previewCharms.innerHTML = '';
      return;
    }

    if (emptyMsg) emptyMsg.style.display = 'none';
    if (cord) cord.style.display = '';

    var html = '';
    for (var i = 0; i < slots.length; i++) {
      if (slots[i]) {
        var pendantClass = slots[i].charm.pendant ? ' is-pendant' : '';
        var rotateStyle = slots[i].charm.rotation ? ' style="transform:rotate(' + slots[i].charm.rotation + 'deg)"' : '';
        html += '<div class="slider-builder__preview-charm' + pendantClass + '" data-slot-index="' + i + '"' + rotateStyle + '>';
        html += '<img src="' + slots[i].charm.image + '" alt="' + slots[i].charm.title + '" />';
        html += '</div>';
      }
    }
    previewCharms.innerHTML = html;
  }

  function refreshAll() {
    updateSlotUI();
    updatePreview();
    updatePricing();
    updateAddToCartState();
  }

  // ── Slot Events ──

  function onSlotClick(e) {
    if (dragJustCompleted) return;
    var btn = e.target.closest('.slider-builder__slot');
    if (!btn) return;

    var index = parseInt(btn.getAttribute('data-slot-index'), 10) - 1;

    // If clicking the remove button
    if (e.target.closest('.slider-builder__slot-remove')) {
      slots[index] = null;
      refreshAll();
      return;
    }

    // If slot is filled, offer replace (open picker for that slot)
    activeSlotIndex = index;
    openPicker();
  }

  // ── Charm Picker ──

  function openPicker() {
    renderPickerGrid();
    picker.setAttribute('aria-hidden', 'false');
    picker.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePicker() {
    picker.setAttribute('aria-hidden', 'true');
    picker.classList.remove('is-open');
    document.body.style.overflow = '';
    activeSlotIndex = null;
  }

  function getFilteredCharms() {
    if (activeTab === 'all') return allCharms;
    if (activeTab === 'letters') return config.charms.letters;
    if (activeTab === 'numbers') return config.charms.numbers;
    if (activeTab === 'decorative') return config.charms.decorative;
    return allCharms;
  }

  function renderPickerGrid() {
    var charms = getFilteredCharms();
    var html = '';

    for (var i = 0; i < charms.length; i++) {
      var charm = charms[i];
      var isIncluded = charm.type === 'letter' || charm.type === 'number';
      var priceLabel = isIncluded ? '' : '<span class="slider-builder__charm-price">+' + formatMoney(charm.price) + '</span>';

      html += '<button type="button" class="slider-builder__charm-card" data-charm-index="' + i + '" data-charm-tab="' + activeTab + '">';
      html += '<div class="slider-builder__charm-img-wrap">';
      html += '<img src="' + charm.image + '" alt="' + charm.title + '" loading="lazy" />';
      html += '</div>';
      html += '<span class="slider-builder__charm-name">' + charm.title + '</span>';
      html += priceLabel;
      html += '</button>';
    }

    if (charms.length === 0) {
      html = '<p class="slider-builder__picker-empty">No charms found</p>';
    }

    pickerGrid.innerHTML = html;
  }

  function onCharmSelect(e) {
    var card = e.target.closest('.slider-builder__charm-card');
    if (!card) return;

    var charmIndex = parseInt(card.getAttribute('data-charm-index'), 10);
    var tab = card.getAttribute('data-charm-tab');
    var charms = tab === 'all' ? allCharms : config.charms[tab === 'letters' ? 'letters' : tab === 'numbers' ? 'numbers' : 'decorative'];
    var charm = charms[charmIndex];
    if (!charm) return;

    // Check max slots
    var filled = getFilledSlots();
    if (activeSlotIndex !== null && !slots[activeSlotIndex] && filled.length >= MAX_SLOTS) {
      return; // all slots full
    }

    // If charm requires photo upload, open photo modal first
    if (charm.photoUpload) {
      pendingPhotoCharm = charm;
      pendingPhotoSlotIndex = activeSlotIndex !== null ? activeSlotIndex : findFirstEmptySlot();
      if (pendingPhotoSlotIndex === null) return;
      closePicker();
      openSliderPhotoUpload();
      return;
    }

    // If activeSlotIndex is set, place charm there
    if (activeSlotIndex !== null) {
      slots[activeSlotIndex] = { slotIndex: activeSlotIndex, charm: charm };
    } else {
      // Find first empty slot
      var placed = false;
      for (var i = 0; i < MAX_SLOTS; i++) {
        if (!slots[i]) {
          slots[i] = { slotIndex: i, charm: charm };
          placed = true;
          break;
        }
      }
      if (!placed) return;
    }

    closePicker();
    refreshAll();
  }

  function onTabClick(e) {
    var tab = e.target.closest('.slider-builder__picker-tab');
    if (!tab) return;

    activeTab = tab.getAttribute('data-tab');

    // Update active state
    var tabs = pickerTabs.querySelectorAll('.slider-builder__picker-tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('is-active');
    }
    tab.classList.add('is-active');

    renderPickerGrid();
  }

  // ── Photo Upload (matches existing theme flow) ──

  function findFirstEmptySlot() {
    for (var i = 0; i < MAX_SLOTS; i++) {
      if (!slots[i]) return i;
    }
    return null;
  }

  var sliderStartModal = document.getElementById('slider-upload-start-modal');
  var sliderUploadModal = document.getElementById('slider-upload-modal');
  var sliderFileInput = document.getElementById('slider-upload-file');
  var sliderContinueBtn = document.getElementById('slider-upload-continue');
  var sliderStartCloseBtn = document.getElementById('sliderUploadStartClose');
  var sliderPinturaContainer = document.getElementById('slider-pintura-editor');
  var sliderUploadSaveBtn = document.getElementById('slider-upload-save');
  var sliderUploadCloseBtn = document.getElementById('sliderUploadClose');
  var sliderPinturaInstance = null;
  var sliderSelectedFile = null;

  var cloudinaryConfig = (window.__photoEditorConfig && window.__photoEditorConfig.cloudinary) || {
    cloudName: 'dgwldii6i',
    uploadPreset: 'ml_unsigned',
    uploadUrl: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload'
  };

  function openSliderPhotoUpload() {
    // Step 1: Show file select modal
    if (!sliderStartModal) return;
    sliderSelectedFile = null;
    if (sliderFileInput) sliderFileInput.value = '';
    if (sliderContinueBtn) sliderContinueBtn.disabled = true;
    sliderStartModal.classList.add('modal--is-active');
    document.body.classList.add('slider-modal-open');
  }

  function onSliderFileSelected(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    sliderSelectedFile = file;
    // Immediately close step 1 and open Pintura (matches existing charm builder flow)
    sliderStartModal.classList.remove('modal--is-active');
    openSliderPinturaModal(file);
  }

  function onSliderContinue() {
    if (!sliderSelectedFile) return;
    sliderStartModal.classList.remove('modal--is-active');
    openSliderPinturaModal(sliderSelectedFile);
  }

  function closeSliderStartModal() {
    if (sliderStartModal) sliderStartModal.classList.remove('modal--is-active');
    document.body.classList.remove('slider-modal-open');
    pendingPhotoCharm = null;
    pendingPhotoSlotIndex = null;
  }

  // Circle mask post-processor (same as theme's DEFAULT shape)
  function circlePostProcess(imageData) {
    return new Promise(function (resolve) {
      var canvas = document.createElement('canvas');
      canvas.width = imageData.width;
      canvas.height = imageData.height;
      var ctx = canvas.getContext('2d');
      ctx.putImageData(imageData, 0, 0);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.fillStyle = 'black';
      ctx.beginPath();
      ctx.arc(imageData.width * 0.5, imageData.height * 0.5, imageData.width * 0.5, 0, 2 * Math.PI);
      ctx.fill();
      resolve(ctx.getImageData(0, 0, canvas.width, canvas.height));
    });
  }

  function openSliderPinturaModal(file) {
    if (!sliderUploadModal) return;

    // Show modal using the same pattern as the theme
    sliderUploadModal.classList.add('modal--is-active');
    document.body.classList.add('slider-modal-open');

    // Reset save button
    sliderUploadSaveBtn.textContent = 'Upload Photo';
    sliderUploadSaveBtn.disabled = false;

    // Initialize Pintura with circle crop overlay + circle mask
    if (typeof pintura !== 'undefined' && pintura.appendDefaultEditor) {
      sliderPinturaContainer.innerHTML = '';
      sliderPinturaInstance = pintura.appendDefaultEditor(sliderPinturaContainer, {
        src: file,
        imageCropAspectRatio: 1,
        cropEnableButtonFlipHorizontal: false,
        cropEnableButtonFlipVertical: false,
        imageCropLimitToImage: true,
        mimeType: 'image/jpeg',
        quality: 0.5,
        targetSize: { width: 1000, height: 1000, fit: 'contain', upscale: false },
        postprocessImageData: circlePostProcess,
        willRenderCanvas: function (shapes, state) {
          var utilVisibility = state.utilVisibility;
          var selectionRect = state.selectionRect;
          var lineColor = state.lineColor;
          var backgroundColor = state.backgroundColor;
          if (utilVisibility.crop <= 0) return shapes;
          var x = selectionRect.x, y = selectionRect.y;
          var width = selectionRect.width, height = selectionRect.height;
          // Circle overlay shape
          var circleShape = {
            x: x + width * 0.5,
            y: y + height * 0.5,
            rx: width * 0.5,
            ry: height * 0.5,
            opacity: utilVisibility.crop,
            inverted: true,
            backgroundColor: [].concat(backgroundColor, [0.5]),
            strokeWidth: 1,
            strokeColor: [].concat(lineColor)
          };
          return Object.assign({}, shapes, {
            interfaceShapes: [].concat(shapes.interfaceShapes, [
              { x: x, y: y, width: width, height: height, opacity: utilVisibility.crop, inverted: true, backgroundColor: [0, 0, 0, 0] },
              circleShape
            ])
          });
        }
      });
    }
  }

  function closeSliderUploadModal() {
    if (!sliderUploadModal) return;
    sliderUploadModal.classList.remove('modal--is-active');
    document.body.classList.remove('slider-modal-open');
    if (sliderPinturaInstance && sliderPinturaInstance.destroy) {
      sliderPinturaInstance.destroy();
      sliderPinturaInstance = null;
    }
    pendingPhotoCharm = null;
    pendingPhotoSlotIndex = null;
  }

  function onSliderUploadSave() {
    if (!sliderPinturaInstance) return;
    sliderUploadSaveBtn.textContent = 'Uploading...';
    sliderUploadSaveBtn.disabled = true;

    sliderPinturaInstance.processImage().then(function (res) {
      var formData = new FormData();
      formData.append('file', res.dest);
      formData.append('upload_preset', cloudinaryConfig.uploadPreset);

      return fetch(cloudinaryConfig.uploadUrl, {
        method: 'POST',
        body: formData
      });
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.secure_url || data.url) {
        var photoUrl = data.secure_url || data.url;
        var thumbUrl = 'https://res.cloudinary.com/' + cloudinaryConfig.cloudName + '/image/upload/c_scale,h_250,w_250/' + data.public_id + '.' + data.format;

        if (pendingPhotoCharm && pendingPhotoSlotIndex !== null) {
          var charmWithPhoto = Object.assign({}, pendingPhotoCharm, {
            photoUrl: photoUrl,
            photoThumb: thumbUrl
          });
          slots[pendingPhotoSlotIndex] = { slotIndex: pendingPhotoSlotIndex, charm: charmWithPhoto };
        }

        closeSliderUploadModal();
        refreshAll();
      } else {
        sliderUploadSaveBtn.textContent = 'Upload failed — try again';
        sliderUploadSaveBtn.disabled = false;
      }
    })
    .catch(function (err) {
      console.error('Slider photo upload error:', err);
      sliderUploadSaveBtn.textContent = 'Upload failed — try again';
      sliderUploadSaveBtn.disabled = false;
    });
  }

  // ── Variant Change Listener (uses existing theme swatch system) ──

  // Cord color map for preview
  var cordColorMap = {
    'tan': '#c8b89a',
    'black': '#222222',
    'white': '#e5e5e5',
    'light blue': '#7ec8c8',
    'winter fresh': '#7ec8c8',
    'blush': '#d4a0a0',
    'dark blue': '#2878b5',
    'true blue': '#2878b5',
    'green': '#3a8a5a',
    'emerald': '#3a8a5a',
    'red': '#c03538'
  };

  function updateCordColor(variantTitle) {
    var color = cordColorMap[(variantTitle || '').toLowerCase()] || '#c8b89a';
    var preview = document.getElementById('sliderPreview');
    if (preview) {
      preview.style.setProperty('--slider-cord-color', color);
    }
  }

  function onVariantChange() {
    var variantSelect = document.querySelector('[name="id"]');
    if (variantSelect) {
      selectedVariantId = parseInt(variantSelect.value, 10);
      // Find the variant price and title from the variants JSON
      var variantsJson = document.querySelector('[id^="VariantsJson-"]');
      if (variantsJson) {
        try {
          var variants = JSON.parse(variantsJson.textContent);
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === selectedVariantId) {
              basePrice = variants[i].price;
              updateCordColor(variants[i].title);
              break;
            }
          }
        } catch (e) {}
      }
      refreshAll();
    }
  }

  // ── Add to Cart ──

  function handleAddToCart() {
    if (addToCartBtn.disabled) return;

    var filled = getFilledSlots();
    if (filled.length === 0) return;

    addToCartBtn.disabled = true;
    addToCartText.textContent = 'Adding...';

    var bundleId = generateBundleId();
    var items = [];

    // Build slot properties for the cord line item
    var cordProperties = {
      '_slider_bundle_id': bundleId,
      '_slider_bundle_parent': 'true',
      '_slider_charm_count': String(filled.length)
    };

    // Add visible slot properties
    var slotNum = 1;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i]) {
        cordProperties['Charm ' + slotNum] = slots[i].charm.title;
        if (slots[i].charm.sku) {
          cordProperties['_Charm ' + slotNum + ' SKU'] = slots[i].charm.sku;
        }
        if (slots[i].charm.photoUrl) {
          cordProperties['_Charm ' + slotNum + ' Photo'] = slots[i].charm.photoUrl;
        }
        slotNum++;
      }
    }

    // Cord bracelet line item
    items.push({
      id: selectedVariantId,
      quantity: 1,
      properties: cordProperties
    });

    // All charms as separate line items (merged by Cart Transform)
    for (var j = 0; j < slots.length; j++) {
      if (slots[j]) {
        items.push({
          id: slots[j].charm.variantId,
          quantity: 1,
          properties: {
            '_slider_bundle_id': bundleId,
            '_slider_bundle_child': 'true',
            '_slot_position': String(j + 1),
            '_charm_title': slots[j].charm.title
          }
        });
      }
    }

    console.log('[SliderBuilder] Adding to cart:', JSON.stringify(items, null, 2));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        addToCartText.textContent = 'Added!';

        // Debug: check cart state after add
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          console.log('[SliderBuilder] Cart after add:', cart.items.length, 'items');
          cart.items.forEach(function(item, i) {
            console.log('[SliderBuilder] Item ' + i + ':', item.title, item.price, 'props:', JSON.stringify(item.properties));
          });
        });

        // Reset builder
        setTimeout(function () {
          slots = [];
          for (var k = 0; k < MAX_SLOTS; k++) slots[k] = null;
          refreshAll();
        }, 1500);

        // Open cart drawer via theme's ajaxCart event
        if (typeof jQuery !== 'undefined') {
          jQuery(document.body).trigger('added.ajaxProduct');
        } else if (typeof $ !== 'undefined') {
          $(document.body).trigger('added.ajaxProduct');
        }
      })
      .catch(function (err) {
        console.error('Slider bracelet add to cart error:', err);
        addToCartText.textContent = 'Error — try again';
        addToCartBtn.disabled = false;
      });
  }

  // ── Init ──

  function init() {
    // Set swatch count CSS variable for dynamic single-row sizing
    var swatchWrap = document.querySelector('form:has(.slider-builder) .variant-input-wrap');
    if (swatchWrap) {
      var swatchCount = swatchWrap.querySelectorAll('.color-swatch').length;
      swatchWrap.style.setProperty('--swatch-count', swatchCount);
    }

    // Initialize empty slots
    for (var i = 0; i < MAX_SLOTS; i++) {
      slots.push(null);
    }

    // Hide default ATC button and quantity (builder has its own)
    var defaultForm = document.querySelector('.product-single__form');
    if (defaultForm) {
      var defaultAtc = defaultForm.querySelector('.add-to-cart-btn');
      if (defaultAtc) defaultAtc.style.display = 'none';

      var qtyWrap = defaultForm.querySelector('.product__quantity');
      if (qtyWrap) qtyWrap.style.display = 'none';

      var paymentBtns = defaultForm.querySelector('.payment-buttons .shopify-payment-button');
      if (paymentBtns) paymentBtns.style.display = 'none';
    }

    var slotsWrap = slotsContainer.parentElement;

    // Suppress native long-press context menu on slots and preview
    slotsContainer.addEventListener('contextmenu', function (e) {
      if (e.target.closest('.slider-builder__slot.is-filled')) e.preventDefault();
    });
    previewCharms.addEventListener('contextmenu', function (e) {
      if (e.target.closest('.slider-builder__preview-charm')) e.preventDefault();
    });

    // Bind drag reorder on slots
    slotsContainer.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest('.slider-builder__slot');
      if (!btn) return;
      if (e.target.closest('.slider-builder__slot-remove')) return;
      var index = parseInt(btn.getAttribute('data-slot-index'), 10) - 1;
      if (!slots[index]) return;
      onDragPointerDown(e, index, 'slots', btn);
    });

    // Bind drag reorder on preview
    previewCharms.addEventListener('pointerdown', function (e) {
      var charm = e.target.closest('.slider-builder__preview-charm');
      if (!charm) return;
      var index = parseInt(charm.getAttribute('data-slot-index'), 10);
      if (isNaN(index) || !slots[index]) return;
      onDragPointerDown(e, index, 'preview', charm);
    });

    // Bind events
    slotsContainer.addEventListener('click', onSlotClick);
    pickerGrid.addEventListener('click', onCharmSelect);
    pickerTabs.addEventListener('click', onTabClick);
    pickerClose.addEventListener('click', closePicker);
    pickerOverlay.addEventListener('click', closePicker);
    addToCartBtn.addEventListener('click', handleAddToCart);

    // Photo upload events — step 1 (file select modal)
    if (sliderFileInput) sliderFileInput.addEventListener('change', onSliderFileSelected);
    if (sliderContinueBtn) sliderContinueBtn.addEventListener('click', onSliderContinue);
    if (sliderStartCloseBtn) sliderStartCloseBtn.addEventListener('click', closeSliderStartModal);
    // Step 2 (pintura editor modal)
    if (sliderUploadSaveBtn) sliderUploadSaveBtn.addEventListener('click', onSliderUploadSave);
    if (sliderUploadCloseBtn) sliderUploadCloseBtn.addEventListener('click', closeSliderUploadModal);

    // Listen for variant changes from existing theme swatch system
    var variantSelect = document.querySelector('[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', onVariantChange);
      // Also observe for programmatic changes (theme JS may set .value directly)
      var observer = new MutationObserver(onVariantChange);
      observer.observe(variantSelect, { attributes: true, childList: true });
    }

    // Listen for color swatch clicks (existing theme pattern)
    var swatchInputs = document.querySelectorAll('.color-swatch-input');
    for (var s = 0; s < swatchInputs.length; s++) {
      swatchInputs[s].addEventListener('change', function () {
        // Small delay to let theme JS update the variant select
        setTimeout(onVariantChange, 50);
      });
    }

    // Picker grid scroll fade — hide fade when scrolled to end
    var gridWrap = document.querySelector('.slider-builder__picker-grid-wrap');
    if (gridWrap) {
      pickerGrid.addEventListener('scroll', function () {
        var atEnd = pickerGrid.scrollLeft + pickerGrid.clientWidth >= pickerGrid.scrollWidth - 2;
        gridWrap.classList.toggle('is-scrolled-end', atEnd);
      });
    }

    // Escape key closes picker
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picker.classList.contains('is-open')) {
        closePicker();
      }
    });

    // Set initial cord color from selected variant
    var variantsJson = document.querySelector('[id^="VariantsJson-"]');
    if (variantsJson) {
      try {
        var variants = JSON.parse(variantsJson.textContent);
        for (var v2 = 0; v2 < variants.length; v2++) {
          if (variants[v2].id === selectedVariantId) {
            updateCordColor(variants[v2].title);
            break;
          }
        }
      } catch (e) {}
    }

    refreshAll();
  }

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
